import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const ANNOUNCEMENT_SHOW = "announcement/show";

export const showAnnouncement = createAsyncThunk(
  ANNOUNCEMENT_SHOW,
  async (thunkAPI) => {
    try {
      const announcement = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}Announcement`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        // filter: ["IsPublish", "=", false],
      });
      return announcement;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
